module.exports = __webpack_public_path__ + "assets/splunk_logo_dark.png";